import React from "react";
import Header from "../../components/Header";
import AccoutSetting from "../../components/AccountSettings";
import { Link } from "react-router-dom";
import { HiOutlineLanguage } from "react-icons/hi2";
import { AiFillHome } from "react-icons/ai";
import { BsFillPersonFill } from "react-icons/bs";
import { LOGOUT } from "../../constants/settingsStrings.js";
import { ArrowLeftIcon } from "@radix-ui/react-icons";
import { SignOutButton } from "@clerk/clerk-react";
import { useNavigate } from "react-router-dom";
import { serverLogout } from "../../hooks/api/useAuth.js";
import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { logoutRedux } from "../../features/userSlice.jsx";

function Logout() {

  const dispatch = useDispatch();
  const userLogout = useMutation({
    mutationFn: serverLogout,
  });
  const navigate = useNavigate();
  const handleSignOut = async (e) => {
    e.preventDefault();
    try {
      await userLogout.mutateAsync();
    } catch (error) {
      console.error("Error signing out:", error);
    } finally {
      dispatch(logoutRedux());
      navigate("/");
    }
  };

  return (
    <div className=" w-full dark:bg-black bg-white  h-screen">
      <div className="bg-[#2A71E8] shadow w-full h-[60px]  sm:hidden mb-2"></div>
      <div className="hidden md:block">
        <Header />
      </div>
      <div className=" sm:flex bg-white dark:bg-black sm:items-center sm:space-x-10 sm:px-10 sm:mt-5 sm:justify-center">
        <div className="hidden md:block">
          {" "}
          <AccoutSetting active={LOGOUT} />
        </div>
        <div className="flex sm:hidden space-x-[100px] px-3">
            <Link to="/settings">
              {" "}
              <ArrowLeftIcon color="gray" className="w-10 h-10 sm:hidden" />
            </Link>

            <h3 className="grid  place-content-center font-bold text-[20px] dark:text-white ">
              Logout
            </h3>
          </div>
        <div className="sm:mt-10 sm:shadow-lg sm:w-[800px] rounded-[25px]   sm:h-[454px] grid place-content-center">
          <div className="border w-full   h-[371px] py-2 sm:w-[231px] sm:h-[271px] rounded-[25px] border-gray-900 items-center justify-center sm:mt-0 mt-[150px]  grid place-content-center">
            <div className="rounded-full   ml-[100px] sm:ml-[70px]  w-[90.82px] h-[90.82px] items-center grid place-content-center    border">
              <img
                src={require("../../assets/img/avater.png")}
                className="px-2 py-2"
              />
            </div>
            <h3 className="text-[15px]   font-sans font-sembold grid place-content-center font-bold">
              Oh no! You’re leaving...
            </h3>
            <h3 className="text-[15px]  font-sans font-sembold grid place-content-center font-bold ml-5">
              Are you sure?
            </h3>
            <button className=" sm:ml-4 bg-[#2A71E8] text-white px-8 items-center   w-[272px] sm:w-[200px]   h-[50px]   m-3 sm:h-[30px] rounded-[20px] mt-4 text-[10px]   ">
              <Link to="/">Naah, Just kidding</Link>{" "}
            </button>
            <SignOutButton >
              <button onClick={handleSignOut} className="sm:ml-4 bg-[#BE2117] text-white w-[272px] m-3 sm:w-[200px] h-[50px] sm:h-[30px] rounded-[20px] mt-2 text-[10px]">
                Yes, Log Me Out
              </button>
            </SignOutButton>

          </div>
        </div>
      </div>
      <div className=" flex justify-between rounded-b-50 fixed bottom-0  sm:hidden px-5  bg-[#2A71E8] mt-5 items-center h-[76px] w-[390px]">
        <AiFillHome color="white" size={35} />
        <HiOutlineLanguage color="white" size={35} />
        <BsFillPersonFill color="#BE2117" size={35} />
      </div>
    </div>
  );
}

export default Logout;
